"use strict";
import { module } from "../app";

module.directive("txtWrapper", [
  "modalService",
  "$http",
  "$compile",
  function (modalService, $http, $compile) {
    return {
      scope: {
        uri: "=",
        onError: "&onError",
        onLoad: "&onLoad",
      },
      link: function (scope, element, attrs) {
        scope.$watch("uri", async function (uri) {
          if (uri) {
            try {
              const response = await fetch(uri, {
                method: "GET",
                mode: "cors",
              });
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              const data = await response.text();
              const content =
                '<div class="txt-content-wrapper"><div class="txt-content"><pre>' +
                data +
                "</pre></div></div>";
              element.empty();
              element.append($compile(content)(scope));
              scope.onLoad();
            } catch (error) {
              console.error("Error loading text document:", error);
              modalService.showErrorMessage(`Error on loading document: ${error.message}`);
              scope.onError({ error });
            }
          }
        });
      },
    };
  },
]);



// WEBPACK FOOTER //
// ./src/scripts/directives/txtWrapper.js